import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import moment from 'moment';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthSessionDto } from 'src/app/app.models';
import { KendoModule } from 'src/app/kendo.module';
import { MaterialModule } from 'src/app/material.module';
import { CustomPipesModule } from 'src/app/pipe/customPipes.module';

@Component({
    selector     : 'clu-nf525requirements-dialog',
    templateUrl  : './clu-nf525requirements-dialog.component.html',
    styleUrls: ['./clu-nf525requirements-dialog.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, KendoModule, TranslateModule, TablerIconsModule, NgScrollbarModule, CustomPipesModule],
    providers : []
})
export class CluNF525RequirementsDialogComponent implements OnInit 
{
    authSessionDto : AuthSessionDto;
    nf525Acknowledged: boolean = false;
    constructor(@Inject(MAT_DIALOG_DATA) private dataE: any, public matDialogRef: MatDialogRef<CluNF525RequirementsDialogComponent>){
        this.authSessionDto = this.dataE.authSessionDto;
    }

    ngOnInit() { }  
    
    doConfirmNF525() {
        localStorage.setItem('LS_BE_NF525REQUIREMENTS_ACK_KEY', 'true');
        this.matDialogRef.close(true);
    }
}